import { GetAccountQuery } from "types/graphql-schema";

import Heading from "@components/heading/heading";

import AiMemory from "../ai-memory/ai-memory";
import MySkillsSection from "./my-skills-section";
import ScheduledAiSection from "./scheduled-ai-section";

const Skills = ({ me }: { me: GetAccountQuery["me"] }) => (
  <div aria-label="AI settings page">
    <Heading small title="AI" />
    <p className="text-sm text-gray-600 mb-8 mt-2">
      Configure how Topicflow AI works for you: reusable skills you can invoke
      with <code className="bg-gray-100 px-1 rounded">/skill-name</code> in
      chat, and a private memory that personalizes responses over time.
    </p>
    {waffle.flag_is_active("ask-ai-scheduled-prompts") && (
      <ScheduledAiSection me={me} />
    )}
    <MySkillsSection />
    {waffle.flag_is_active("ask-ai-memory") && <AiMemory />}
  </div>
);

export default Skills;
